import { privateRequestV1 } from '@/services/axios/api'
import {
  errorHandler,
  TreeunfeAxiosError,
} from '@/services/axios/error-handler'
import { IUSersService } from '../interfaces/users-service-interface'

export const UsersService: IUSersService = {
  async getMe() {
    try {
      const response = await privateRequestV1.get('/users')
      return response.data
    } catch (error: unknown | TreeunfeAxiosError) {
      errorHandler(error as TreeunfeAxiosError)
    }
  },
}
